import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#444BA2',
                secondary: '#3d4246',
                accent: '#8c9eff',
                error: '#b71c1c',
                faded:'#dadde5',
                background:'#f6f7f9',
                callout: '#ff6c6c',
                maintenance: '#8a90e8',
                task:'#abbac5'
            },
        },
    },
});
